module.exports = __webpack_public_path__ + "static/media/kredyt_31.caf793f9.png";